import React from 'react';
import fascilitatorTrainingRoutes, {
  FACILITATOR_CERTIFICATE_ROUTE,
  flatFacilitatorRoutes,
} from './flow';
import { Route, Switch, Redirect, useRouteMatch } from 'react-router-dom';
import HomePAge from './pages/HomePAge';
import ResourceLibrary from './pages/ResourceLibrary';
import { hasFullFacilitatorProgramAccessRole } from '../../../../utils/authRole';
const Routes = () => {
  const { path } = useRouteMatch();
  const hasFullFacilitatorProgramAccess =
    hasFullFacilitatorProgramAccessRole(localStorage.getItem('role'));
  return (
    <Switch>
      <Route key={'home'} path={`${path}/home`} exact>
        <HomePAge />
      </Route>
      <Route key={'home'} path={`${path}/resource-library`} exact>
        <ResourceLibrary />
      </Route>
      {flatFacilitatorRoutes.map((route, index) => {
        const routePath = `${path}/${route.fullPath}`;
        console.log(routePath, 'routePath');
        return (
          <Route key={index} path={routePath} exact>
            {hasFullFacilitatorProgramAccess &&
            route.fullUrl === FACILITATOR_CERTIFICATE_ROUTE ? (
              <Redirect to={`${path}/resource-library`} />
            ) : (
              <div className='p-4 h-full w-full'>{route.component}</div>
            )}
          </Route>
        );
      })}
      {fascilitatorTrainingRoutes.map((route) => {
        if (route.subRoutes) {
          return (
            <Route key={route.id} path={`${path}/${route.url}`} exact>
              <Redirect to={`${path}/${route.url}/${route.subRoutes[0].url}`} />
            </Route>
          );
        }
        if (route.sections) {
          return route.sections.map((section) => {
            console.log(`${path}/${route.url}/${section.url}`, 'path section');
            return (
              <Route
                key={section.id}
                path={`${path}/${route.url}/${section.url}`}
                exact
              >
                <Redirect
                  to={`${path}/${route.url}/${section.url}/${section.subRoutes[0].url}`}
                />
              </Route>
            );
          });
        }
        return null; // Ensure all branches return a value
      })}
    </Switch>
  );
};

export default Routes;
